import React, {
  useRef,
  useMemo,
  useEffect,
  useCallback,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { Button } from '@material-ui/core';
import { Delete, GridOn } from '@material-ui/icons';
import CachedIcon from '@material-ui/icons/Cached';
import { parseISO, format } from 'date-fns';
import { isArray } from 'lodash';
import moment from 'moment';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteOperacaoAbastecimentoExterno,
  findOperacaoAbastecimentoExterno,
  recordFiltering,
} from '~/store/modules/operacaoabastecimentoexterno/actions';

import DialogConfirmation from './components/DialogConfirmation';
import DialogMensagem from './components/DialogMensagem';
import Form from './form';

function OperacaoAbastecimentoList() {
  const redux = useSelector((state) => state.operacaoabastecimentoexterno);
  const { opened } = useSelector((state) => state.dialog);

  const dispatch = useDispatch();

  const deleteRef = useRef(null);

  const [openStatistic, setOpenStatistic] = useState(false);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const buttons = useMemo(
    () => [
      {
        title: 'excluir',
        action: (value) => deleteRef.current.handleOpen(value),
        icon: <Delete />,
      },
    ],
    []
  );

  const mensagemOptions = useMemo(
    () => [
      { label: 'V', value: t('Válidos') },
      { label: 'I', value: t('Inconsistentes') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'dataemissaoabastnf_inicio',
        label: 'Data/Hora (Inicio)',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy'),
        filter: {
          type: 'initialdatetime',
          defaultValue: start.format('DD/MM/YYYY HH:mm:ss'),
        },
      },
      {
        id: 'dataemissaoabastnf_fim',
        label: 'Data/Hora (fim)',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy'),
        filter: {
          type: 'finaldatetime',
          defaultValue: end.format('DD/MM/YYYY HH:mm:ss'),
        },
      },
      {
        id: 'numeroabastnf',
        label: 'Número NF',
        filter: { type: 'text' },
      },
      {
        id: 'cnpjdistribuidoraabastnf',
        label: 'CNPJ NF',
        filter: { type: 'text' },
        formatted: (value) =>
          value.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            '$1.$2.$3/$4-$5'
          ),
      },
      {
        id: 'nomeposto',
        label: 'Nome',
        filter: { type: 'text' },
      },
      {
        id: 'placactabastnf',
        label: 'Placa',
        filter: { type: 'text' },
      },
      {
        id: 'motoristaabastnf',
        label: 'Motorista',
        filter: { type: 'text' },
      },
      {
        id: 'mensagemabastnf',
        label: 'Status',
        // filter: {
        //   type: 'multicombobox',
        //   options: statusAbastecimento,
        //   name: 'Status',
        //   title: 'Status',
        // },
        filter: { type: 'select', options: mensagemOptions, defaultValue: 'I' },
      },
      {
        id: 'chavenf',
        label: 'Chave NF',
        filter: { type: 'text' },
      },
    ],
    []
  );

  const handleStatisticModal = () => {
    setOpenStatistic((prevState) => !prevState);
  };

  const handleFetchData = useCallback(async () => {
    try {
      if (!redux.loading) {
        dispatch(recordFiltering(redux.params));
      }
    } catch (errors) {
      if (isArray(errors)) errors.map((error) => toast.error(t(error)));
      else toast.error(t(errors));
    }
  }, [redux]);

  const handleRefresh = useCallback(async () => {
    try {
      if (!redux.loading) {
        dispatch(recordFiltering(redux.params));
      }
    } catch (errors) {
      if (isArray(errors)) errors.map((error) => toast.error(t(error)));
      else toast.error(t(errors));
    }
  }, [redux]);

  function Toolbar() {
    return (
      <>
        <Button
          variant="contained"
          size="small"
          color="primary"
          startIcon={<GridOn />}
          onClick={() => setOpenStatistic(!openStatistic)}
        >
          {t('Estatistica')}
        </Button>
        <Button
          variant="contained"
          size="small"
          color="primary"
          startIcon={<CachedIcon />}
          onClick={() => handleRefresh()}
        >
          {t('Atualizar')}
        </Button>
      </>
    );
  }

  useEffect(() => {
    const isTime = setInterval(() => {
      if (!opened) {
        handleFetchData();
      }
    }, 60000);

    return () => clearInterval(isTime);
  }, [redux, opened]);

  return (
    <>
      <UnidataTable
        fixed
        delete={false}
        actions={buttons}
        redux={redux}
        header={header}
        read={recordFiltering}
        find={findOperacaoAbastecimentoExterno}
        remove={deleteOperacaoAbastecimentoExterno}
        keys={['idabastnf']}
        form={Form}
        toolbar={Toolbar}
        update
      />
      <DialogConfirmation
        ref={deleteRef}
        keys={['idabastnf']}
        title="Justificativa para cancelamento da NF"
        redux={deleteOperacaoAbastecimentoExterno}
        query={redux.params}
      />
      <DialogMensagem
        open={openStatistic}
        onClose={handleStatisticModal}
        title="Estatística de Conversão de Abastecimento"
      />
    </>
  );
}

export default OperacaoAbastecimentoList;
